// 导出配置的路由器
export default [{
  path: '/systemManagement',
  component: () => import('@/layout/index'),
  redirect: 'systemManagement/systemParamManage',
  meta: {
    title: '系统管理',
    icon: 'icon-xitong',
    perms: ['bee:system']
  },
  children: [
    {
      path: 'systemParamManage',
      component: () => import('@/module/maintenanceCenter/page/systemParam/manage.vue'),
      meta: {icon: 'icon-shebei2', title: '系统参数', perms: ['bee:ops:systemParam']}
    },
    {
      path: 'paymentType',
      component: () => import('@/module/systemManagement/page/paymentType/manage.vue'),
      meta: {
        title: '支付方式',
        icon: 'icon-jifen2',
        perms: ['bee:system:paymentType']
      }
    },
    {
      path: 'authorityManagement',
      component: () => import('@/module/systemManagement/page/authority/manage.vue'),
      meta: {
        title: '权限管理',
        icon: 'icon-quanxian3',
        perms: ['bee:system:user']
      }
    },
    {
      path: 'userPayment',
      component: () => import('@/module/systemManagement/page/userPayment.vue'),
      meta: {
        title: '支付渠道管理',
        icon: 'icon-shangjia',
        perms: ['bee:pay:operatorPayment']
      }
    },
    {
      path: 'systemLogInfoManager',
      component: () => import('@/module/systemManagement/page/systemLogInfo/manage.vue'),
      meta: {
        title: '操作日志',
        icon: 'icon-caozuo',
        perms: ['bee:system:systemLogInfo']
      }
    },
    // {
    //   path: 'personalSettings',
    //   component: () => import('@/module/systemManagement/page/personalSettings.vue'),
    //   hidden: true,
    //   meta: {
    //     title: '个人设置',
    //     icon: 'icon-geren'
    //   }
    // }
  ]
}, {
  path: '/personalCenter',
  component: () => import('@/layout/index'),
  redirect: 'personalCenter/personalSettings',
  // hidden: true,
  meta: {
    title: '个人中心',
    icon: 'icon-geren'
  },
  children: [
    {
      path: 'personalSettings',
      name: 'personalSettings',
      component: () => import('@/module/systemManagement/page/personalSettings.vue'),
      meta: {
        title: '个人设置',
        icon: 'icon-caozuo'
      }
    }
  ]
},{
  path: '/strategyCenter',
  component: () => import('@/layout/index'),
  redirect: 'strategyCenter/xxxxx',
  // hidden: true,
  meta: {
    title: '策略中心',
    icon: 'icon-geren'
  },
  children: [
    {
      path: 'rule',
      component: () => import('@/module/strategyCenter/page/rule/ruleManage.vue'),
      meta: {
        title: '规则',
        icon: 'icon-caozuo',
      }
    },

    {
      path: 'ruleSecene',
      name: 'xxxx',
      component: () => import('@/module/strategyCenter/page/scene/sceneManage.vue'),
      meta: {
        title: '场景',
        icon: 'icon-caozuo'
      }
    },

    {
      path: 'action',
      name: 'xxxx',
      component: () => import('@/module/strategyCenter/page/action/actionManage.vue'),
      meta: {
        title: '动作',
        icon: 'icon-caozuo'
      }
    },

    {
      path: 'entity',
      component: () => import('@/module/strategyCenter/page/entity/entityManage.vue'),
      meta: {
        title: '实体',
        icon: 'icon-caozuo'
      }
    },

    {
      path: 'property',
      component: () => import('@/module/strategyCenter/page/property/propertyManage.vue'),
      meta: {
        title: '属性',
        icon: 'icon-caozuo'
      }
    },

  ]
}]



// WEBPACK FOOTER //
// ./src/module/systemManagement/router/index.js